import React, { useState } from 'react';
import I18n from 'i18n-js';
import { Button, Col, Modal, Row } from 'reactstrap';
import { PeriodType } from '../../../models/coupon/PeriodType';
import DateUtility from '../../../blocks/utils/date-utility';
import NumberUtility from '../../../blocks/utils/number-utility';
import Coupon from '../../../models/coupon/Coupon';
import MapJLS from '../../shared/maps/MapJLS';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../store';
import TrafficAreaUtility from '../../../blocks/utils/traffic-area-utility/TrafficAreaUtility';
import PinDropIcon from '@material-ui/icons/PinDrop';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import EuroUtility from '../../../blocks/utils/euro-utility';
import CurrencyUtility from '../../../blocks/utils/currency-utility/CurrencyUtility';

interface Props {
    coupon: Coupon;
    purchaseCouponClicked: () => void;
};

const CouponSearchItem = (props: Props) => {
    const [modalIsOpen, setModalIsOpen] = useState<boolean | undefined>(false);

    const trafficAreas = useSelector((state: ApplicationState) => state.tariff.trafficAreas);

    const goToMaps = () => {
        setModalIsOpen(true);
    };

    return (
        <>
            <div className='ticket-search-item mt-4'>
                <Row>
                    <Col xl={6} md={6} sm={12}>
                        <div className='d-md-none map-pin'>
                            <span onClick={goToMaps} className="cursor-pointer">
                                <PinDropIcon className="icon-pin" />
                            </span>
                        </div>
                        <div className='primary-color'>
                            <Row>
                                <h4>{props.coupon.relation.caption}</h4>
                            </Row>
                        </div>
                        <div className='primary-color lower-opacity mb-4 smaller-font'>
                            <Row className='mb-1'>
                                <span>{`${I18n.t('tickets.details.alsoWorth')}:`}</span><span className='pl-2 font-weight-500'>{TrafficAreaUtility.getNames(props.coupon.relation.trafficAreas, trafficAreas)}</span>
                            </Row>
                            <Row className='mb-1'>
                                <span>{`${I18n.t('tickets.details.numberOfTrips.title')}:`}</span><span className='pl-2 font-weight-500'>{I18n.t('tickets.details.numberOfTrips.unlimited')}</span>
                            </Row>
                        </div>
                        <div className='mt-4 mb-2'>
                            <Row className='mb-1'>
                                <span>{`${I18n.t('tickets.ticketType')}:`}</span><span className='pl-2 font-weight-500'>{props.coupon.period?.type === PeriodType.Monthly ? I18n.t('tickets.details.couponType.monthly') : I18n.t('tickets.details.couponType.yearly')}</span>
                            </Row>
                            <Row className='mb-1'>
                                <span>{`${I18n.t('tickets.details.worthForPeriod')}:`}</span><span className='pl-2 primary-color'>{`${DateUtility.format(props.coupon.validFrom, 'dd/mm/yyyy')} - ${DateUtility.format(props.coupon.validTo, 'dd/mm/yyyy')}`}</span>
                            </Row>
                            <Row className='mb-1'>
                                <span>{`${I18n.t('price')}:`}</span><span className='pl-2 font-weight-500 primary-color'>{`${NumberUtility.format(props.coupon.price || 0, 2, true, false, ',')} ${CurrencyUtility.getPrimaryCurrencyById(props.coupon.currencyId).sign} (${EuroUtility.convert(props.coupon.price)} ${CurrencyUtility.getSecondaryCurrencyById(props.coupon.currencyId).sign})`}</span>
                            </Row>
                            {
                                props.coupon.discount &&
                                <Row className='mb-1'>
                                    <span>{`${I18n.t('tickets.details.discount')}:`}</span><span className='pl-2 font-weight-500'>{props.coupon.discount.caption}</span>
                                </Row>
                            }
                        </div>
                        {
                            props.coupon.subsidy &&
                            <div className='mt-4 mb-2'>
                                <Row className='mb-1'>
                                    <span>{`${I18n.t('tickets.details.subsidy')}:`}</span><span className='pl-2 font-weight-500'>{props.coupon.subsidy.caption}</span>
                                </Row>
                            </div>
                        }
                        <div className='mt-4 mb-2 d-none d-md-block'>
                            <Row className='mb-1'>
                                <Button className='buy-button' type="button" color="primary" onClick={props.purchaseCouponClicked}>{I18n.t('tickets.buyCoupon')}</Button>
                            </Row>
                        </div>
                        <div className='mt-4 mb-2 d-block d-md-none'>
                            <Row className='mb-1'>
                                <Button className='w-100' type="button" color="primary" onClick={props.purchaseCouponClicked}>{I18n.t('tickets.buyCoupon')}</Button>
                            </Row>
                        </div>
                    </Col>
                    <Col className='d-none d-md-block' xl={6} md={6} sm={12}>
                        <MapJLS trafficAreas={props.coupon.relation.trafficAreas} />
                    </Col>
                </Row>
            </div>
            <Modal isOpen={modalIsOpen} onRequestClose={() => setModalIsOpen(false)}>
                <div className='d-flex justify-content-between align-items-center p-2'>
                    <div>
                        <span>{I18n.t('tickets.buy.mapViewModalTitle')}</span>
                    </div>
                    <div onClick={() => setModalIsOpen(false)} className="cursor-pointer">
                        <CloseOutlinedIcon className="icon-pin" />
                    </div>
                </div>
                <div>
                    <MapJLS trafficAreas={props.coupon.relation.trafficAreas} fullView />
                </div>
            </Modal>
        </>
    );
}

export default CouponSearchItem;
